import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { NavigationLink } from '@domgen/dgx-fe-business-models';

@Component({
  selector: 'dgx-ui-wl-footer-navigation',
  templateUrl: './footer-navigation.component.html',
  styleUrls: ['./footer-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterNavigationComponent {
  @Input() protectLinks?: NavigationLink[];
  @Input() moreLinks?: NavigationLink[];
  @Input() usefulLinks?: NavigationLink[];
  @Input() legalLinks?: NavigationLink[];

  @Output() clicked = new EventEmitter<{
    event: MouseEvent;
    link: string;
  }>();

  public handleLinkClick(event: MouseEvent, link: string) {
    this.clicked.emit({ event, link });
  }
}
